// Matches compute_invoice_tax: every non-zero business tax rate is applied
// to the pre-tax amount, independently, with the same cent rounding.
// rate_bps = ROUND(rate * 100); tax = ROUND(net_cents * rate_bps / 10000).

export interface SubscriptionTaxRate {
  name: string;
  rate: number;
}

export interface SubscriptionTaxLine {
  name: string;
  rate: number;
  amountCents: number;
}

export interface SubscriptionTaxQuote {
  netCents: number;
  taxCents: number;
  totalCents: number;
  lines: SubscriptionTaxLine[];
}

export function quoteSubscriptionTax(
  amountDollars: number,
  rates: SubscriptionTaxRate[],
): SubscriptionTaxQuote {
  const netCents = Math.round((Number(amountDollars) || 0) * 100);
  const lines: SubscriptionTaxLine[] = [];
  for (const rate of rates) {
    const r = Number(rate.rate) || 0;
    if (r === 0) continue;
    const rateBps = Math.round(r * 100);
    const amountCents = Math.round((netCents * rateBps) / 10000);
    if (amountCents === 0) continue;
    lines.push({ name: rate.name || 'Tax', rate: r, amountCents });
  }
  lines.sort((a, b) => a.name.localeCompare(b.name));
  const taxCents = lines.reduce((sum, line) => sum + line.amountCents, 0);
  return { netCents, taxCents, totalCents: netCents + taxCents, lines };
}

export function formatTaxCents(cents: number): string {
  return (cents / 100).toFixed(2);
}

export function formatTaxRate(rate: number): string {
  const n = Number(rate) || 0;
  return Number.isInteger(n) ? String(n) : n.toFixed(2).replace(/0+$/, '').replace(/\.$/, '');
}
